import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const TermsOfServicePageMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "mobile" */ "~/components/desktop/pages/TermsOfService"
    ),
  loading: LoadableLoading
});
const TermsOfServicePageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "desktop" */ "~/components/desktop/pages/TermsOfService"
    ),
  loading: LoadableLoading
});

class DetectTermsOfService extends Component {
  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <TermsOfServicePageMobile />
        ) : (
          <TermsOfServicePageDesktop />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    }
  } = state;
  return {
    device: type
  };
};

const TermsOfServiceHelmet = withTitle({
  component: DetectTermsOfService,
  title: `${hospitalName.value} | Điều khoản dịch vụ`
});

export default connect(mapStateToProps)(TermsOfServiceHelmet);
